import LineMarker from '../LineMarker';
import { CircleDisplayType, LineType } from '../LineMarker/line-markers.enum';
import Colors from '../../../../../../../../helpers/colors.helper';
import EstimatedAndPlannedTimes from '../shared/EstimatedAndPlannedTimes';
import { IMicromobilityLink, MicromobilityLinkType } from '../../../../../../../../models/labs/micromobility/micromobility-link.model';

function MicromobilityLinkSection({micromobilityLink, className = '', endDestination = undefined, children}: {micromobilityLink: IMicromobilityLink; className?: string; endDestination: string | undefined; children: React.ReactNode; }) {

  return (
    <li className={`micromobility-link-section d-flex overflow-hidden print-no-break ${className}`}>
      <LineMarker
        foregroundColor={Colors.vtdBlue1000}
        backgroundColor={Colors.vtdWhite}
        lineColor={Colors.vtdBlue1000}
        lineType={LineType.solid}
        circleDisplayType={CircleDisplayType.both}
        className="flex-shrink-0"
      />
      <div className="flex-grow-1 ms-2">
        <EstimatedAndPlannedTimes estimatedTime={micromobilityLink.plannedDepartureTime} plannedTime={micromobilityLink.plannedDepartureTime} isCancelled={false} className="mb-1 micromobility-link-section__times" />
        {micromobilityLink.type === MicromobilityLinkType.stationBound && (
          <div className="mb-1">
            <span className="h4">{micromobilityLink.originStation?.name}</span>
          </div>
        )}
        <div className={`mb-2`}>{children}</div>
        {endDestination && (
          <div className="mb-1">
            <span className="h4">{endDestination}</span>
          </div>
        )}
        {micromobilityLink.type === MicromobilityLinkType.stationBound && (
          <div className="mb-1">
            <span className="h4">{micromobilityLink.destinationStation?.name}</span>
          </div>
        )}
        <EstimatedAndPlannedTimes estimatedTime={micromobilityLink.plannedArrivalTime} plannedTime={micromobilityLink.plannedArrivalTime} isCancelled={false} className="micromobility-link-section__times" />
      </div>
    </li>
  );
}

export default MicromobilityLinkSection;
